module.exports = __webpack_public_path__ + "assets/avatar_utility.f389685a.svg";